import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { TedChatBubbleIcon } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'g99-lib-ted-button',
  templateUrl: './ted-button.component.html',
  styleUrls: ['./ted-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TedButtonComponent {
  @Output() public pressed = new EventEmitter<void>();

  protected tedIcon = TedChatBubbleIcon;

  public onClick(): void {
    console.log('Ted button clicked!');
    this.pressed.emit();
  }
}
